<!--test-->
<template>
  <div class="table-manage-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">订单编号：</p>
              <el-input
                type="number"
                placeholder="请输入"
                v-model="filters.oid"
                size="small"
                class="input"
                @keyup.enter.native="getOrderList"
              />
            </div>
            <div class="filter-item">
              <p class="label">用户ID：</p>
              <el-input
                type="number"
                placeholder="请输入"
                v-model="filters.uid"
                size="small"
                class="input"
              />
            </div>
            <div class="filter-item">
              <p class="label">订单状态：</p>
              <el-select
                v-model="filters.status"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <!-- <div class="filter-item">
              <p class="label">商品商家：</p>
              <el-select
                v-model="filters.sid"
                size="small"
                class="input"
                style="margin: 0 10px"
                placeholder="全部"
              >
                <el-option :value="null" label="全部"> </el-option>
                <el-option
                  :value="item.id"
                  :label="item.name"
                  v-for="item in businessList"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <!-- <div class="filter-item">
              <p class="label">支付方式：</p>
              <el-select
                v-model="filters.type"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="filter-item">
              <p class="label">支付方式：</p>
              <el-select
                v-model="filters.genre"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in genreList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <p class="label">所属商家：</p>
              <!-- <el-select
                v-model="filters.genre"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option
                  v-for="item in genreList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
              <el-input
                type="number"
                placeholder="请输入"
                v-model="filters.shopName"
                size="small"
                class="input"
              />
            </div>
            <div class="filter-item" style="margin: 0 10px">
              <p class="label">省：</p>
              <el-select
                @change="provinceChange"
                v-model="province"
                placeholder="全部"
                size="small"
                class="input"
              >
                <el-option
                  v-for="item in areaArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item" style="margin: 0 10px">
              <p class="label">市：</p>
              <el-select
                @change="cityChange"
                v-model="city"
                placeholder="全部"
                size="small"
                class="input"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item" style="margin: 0 10px">
              <p class="label">区：</p>
              <el-select
                @change="countryChange"
                v-model="filters.county"
                placeholder="全部"
                size="small"
                class="input"
              >
                <el-option
                  v-for="item in countyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <p class="label">下单时间：</p>
              <el-date-picker
                style="margin: 0 10px"
                size="small"
                class="date-input"
                v-model="timeRange"
                type="datetimerange"
                align="right"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div class="btn-box">
              <button class="search" @click="doSearch">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
            <div class="import-box">
              <button class="search btn">
                <input
                  class="search-input"
                  type="file"
                  ref="import"
                  id="impExcel"
                  @change="impExcel"
                  accept="*.xls"
                />导入
              </button>
              <button class="search btn" @click="order2excel()">导出</button>
            </div>
          </div>
        </div>
        <el-table
          :data="orderList"
          class="order-table table no-border-table"
          id="table"
          ref="multipleTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="oid" label="订单编号" align="center">
          </el-table-column>
          <el-table-column prop="uid" label="用户ID" align="center">
          </el-table-column>
          <el-table-column
            prop="area"
            label="收货地区"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  `${scope.row.provinceStr}/${scope.row.cityStr}/${scope.row.countyStr}`
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payment" label="付款金额/元" align="center">
          </el-table-column>
          <el-table-column prop="payment" label="所属商户" align="center">
          </el-table-column>
          <el-table-column label="订单状态" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.status | getOrderState }}</div>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" align="center">
            <template slot-scope="scope">
              <div>{{ typeMap[scope.row.type] || "- -" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="160"
            align="center"
            prop="created"
            label="下单时间"
          >
          </el-table-column>
          <el-table-column prop="method" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="onItemClick(scope.$index, scope.row)"
                >查看订单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          @current-change="PageChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import myUtils from '../../components/common/whatever2excel';
import Header from '../../components/common/header';
import XLSX from 'xlsx';
let that;
export default {
  name: 'orderManager',
  components: { Header },
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '订单管理',
        secondTitle: '订单管理'
      },
      statusList: [
        {
          id: 0,
          val: '全部'
        },
        {
          id: 2,
          val: '待支付'
        },
        {
          id: 8,
          val: '待发货'
        },
        {
          id: 10,
          val: '已备货'
        },
        {
          id: 16,
          val: '待收货'
        },
        {
          id: 18,
          val: '已收货'
        }
      ], // 状态列表
      statusMap: {
        2: '待支付',
        8: '待发货',
        10: '已备货',
        16: '待收货',
        18: '已收货'
      },
      typeList: [
        {
          id: 0,
          val: '全部'
        },
        {
          id: 1,
          val: '微信支付'
        },
        {
          id: 2,
          val: '余额支付'
        },
        {
          id: 3,
          val: '悦贝支付'
        }
      ],
      genreList: [
        {
          id: 1,
          val: '商城自营'
        },
        {
          id: 2,
          val: '供应链'
        }
      ],
      typeMap: {
        1: '微信支付',
        2: '余额支付',
        3: '悦贝支付'
      },
      areaData: {
        provinceList: [],
        cityList: [],
        countyList: []
      },
      currentCityList: [],
      currentCountyList: [],
      province_str: '',
      city_str: '',
      country_str: '',
      areaObj: {
        city_list: {},
        county_list: {},
        province_list: {}
      },
      orderList: [],
      loading: 0,
      currentPage: 1, // 当前页
      size: 20, // 当前页条数
      totalSize: 0, // 共多少条数据
      pageCount: 0,
      timeRange: null,
      filters: {
        oid: '', // 订单id
        province: '', // 省编号
        city: '', // 市编号
        county: '', // 区编号
        pay_channel: '', // 支付方式
        user_phone: '', // 收货电话
        uid: '', // 用户id
        status: '', // 订单状态
        start_time: '',
        end_time: '',
        type: 0,
        sid: null,
        genre: 1
      },
      areaArr: [],
      city: {},
      province: {},
      cityList: [],
      countyList: [],
      provinceList: [],
      businessList: [],
      importArr: {
        订单号: 'oid',
        物流公司: 'company',
        物流单号: 'code'
      },
      showProgressDialog: false,
      progress: 0
    };
  },
  filters: {
    getOrderState(code) {
      let state = '无';
      that.statusList.forEach((item) => {
        if (item.id === code) {
          state = item.val;
        }
      });
      return state;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'orderDetail') {
      sessionStorage.setItem('orderManage', '');
    }
    next();
  },
  created() {
    that = this;
    this.getArea();
    // this.getBusinessList();
    // this.getOrderStatus()
    let data = sessionStorage.getItem('orderManage')
      ? JSON.parse(sessionStorage.getItem('orderManage'))
      : '';
    if (data) {
      this.filters = {
        ...this.filters,
        ...data.filters
      };
      this.timeRange = data.timeRange;
      this.currentPage = data.currentPage;
      this.setSearchData();
    }
    this.getOrderList();
  },
  methods: {
    setSearchData() {
      let orderManage = {
        currentPage: this.currentPage,
        filters: this.filters,
        timeRange: this.timeRange
      };
      sessionStorage.setItem('orderManage', JSON.stringify(orderManage));
    },
    onItemClick(index, row) {
      // 跳转详情
      console.log(index, row);
      this.$router.push({
        name: 'orderDetail2',
        query: { id: row.oid }
      });
    },
    reset() {
      this.filters = {
        oid: '', // 订单id
        province: '', // 省编号
        city: '', // 市编号
        county: '', // 区编号
        pay_channel: '', // 支付方式
        user_phone: '', // 收货电话
        uid: '', // 用户id
        status: '', // 订单状态
        start_time: '',
        end_time: '',
        type: 0,
        sid: null,
        genre: 1
      };
      this.city = {};
      this.province = {};
      this.timeRange = null;
      this.getOrderList();
    },
    getBusinessList() {
      this.loading++;
      this.httpGet(this.$root.getBusinessList, {
        size: 9999
      }).then(
        (res) => {
          this.loading--;
          this.businessList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 确定筛选
    doSearch() {
      this.currentPage = 1;
      this.getOrderList();
    },
    provinceChange(val) {
      // this.province_str = this.areaObj.province_list[val];
      this.filters.province = val.value;
      this.cityList = val.children;
    },
    cityChange(val) {
      // this.city_str = this.areaObj.city_list[val];
      this.filters.city = val.value;
      this.countyList = val.children;
    },
    countryChange(val) {
      // this.country_str = this.areaObj.county_list[val];
    },
    // 分页
    PageChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },
    getArea() {
      this.loading++;
      this.httpGet(this.$root.getArea).then(
        (res) => {
          this.loading--;
          // 根据市 划分区
          let countyObj = {};
          for (let countyId in res.county_list) {
            let cId = (countyId + '').substring(0, 4);
            if (countyObj[cId]) {
              countyObj[cId].push({
                label: res.county_list[countyId],
                value: +countyId
              });
            } else {
              countyObj[cId] = [
                {
                  label: res.county_list[countyId],
                  value: +countyId
                }
              ];
            }
          }
          // 根据省 划分市
          let areaArr = [];
          let cityObj = {};
          // let cityEmptyObj = {};
          for (let cityId in res.city_list) {
            let pId = (cityId + '').substring(0, 2);
            if (cityObj[pId]) {
              cityObj[pId].push({
                label: res.city_list[cityId],
                value: +cityId,
                children: countyObj[(cityId + '').substring(0, 4)]
              });
            } else {
              cityObj[pId] = [
                {
                  label: res.city_list[cityId],
                  value: +cityId,
                  children: countyObj[(cityId + '').substring(0, 4)]
                }
              ];
            }
          }
          for (let provinceId in res.province_list) {
            areaArr.push({
              value: +provinceId,
              label: res.province_list[provinceId],
              children: cityObj[(provinceId + '').substring(0, 2)]
            });
          }
          // console.log(areaArr);
          this.areaArr = areaArr;
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    format2list(obj) {
      let List = [
        {
          name: '全部',
          code: ''
        }
      ];
      Object.keys(obj).forEach((item) => {
        List.push({
          name: obj[item],
          code: item
        });
      });
      return List;
    },
    getOrderList() {
      this.setSearchData();
      this.loading++;
      let data = {
        page: this.currentPage,
        size: this.size,
        oid: +this.filters.oid,
        uid: +this.filters.uid, // 用户id
        status: +this.filters.status, // 订单状态
        begin: this.filters.start_time,
        end: this.filters.end_time,
        province: this.filters.province, // 省
        city: this.filters.city, // 市
        county: this.filters.county, // 区
        type: this.filters.type,
        sid: this.filters.sid,
        genre: this.filters.genre
      };
      if (this.filters.status === '') {
        delete data.status;
      }
      if (this.filters.oid === '') {
        delete data.oid;
      }
      if (this.filters.uid === '') {
        delete data.uid;
      }
      if (this.filters.pay_channel === '') {
        delete data.pay_channel;
      }
      this.httpGet(this.$root.orderList, data).then(
        (res) => {
          this.orderList = res.list;
          this.totalSize = parseInt(res.total);
          this.loading--;
        },
        () => {
          this.loading--;
        }
      );
    },
    getOrderStatus() {
      this.loading++;
      this.httpPost(this.$root.getOrderStatus, {}).then(
        (res) => {
          this.statusList = [
            {
              id: '',
              val: '全部'
            }
          ];
          for (let i in res.list) {
            let item = {
              id: i,
              val: res.list[i]
            };
            this.statusList.push(item);
          }
          this.loading--;
        },
        () => {
          this.loading--;
        }
      );
    },
    impExcel(e) {
      // 导入信息
      //   const that = this;
      let fileName = e.target.files[0];
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        // 启动函数
        reader.readAsBinaryString(fileName);
        reader.onload = function (e) {
          const workbook = XLSX.read(e.target.result, {
            type: 'binary'
          });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const results = XLSX.utils.sheet_to_json(worksheet);
          console.log(5555, results);
          let list = [];
          results.forEach((item, i) => {
            let obj = {};
            for (let key in item) {
              if (typeof that.importArr[key] !== 'undefined') {
                let filed = that.importArr[key];
                obj[filed] = item[key] || '';
              }
            }
            list.push(obj);
          });

          that.upFile(list);
          that.$refs.import.value = '';
        };
      });
    },
    upFile(list) {
      // 校验数据
      let isPass = true;
      list.forEach((item, i) => {
        if (!isPass) {
          return false;
        }
        for (let j in this.importArr) {
          let key = this.importArr[j];
          // if (item[key] === '' || typeof item[key] === 'undefined') {
          //   this.$message.warning(`请完善第${+i + 2}行${j}的数据！`);
          //   isPass = false;
          //   return false;
          // }
          if (['oid'].includes(key)) {
            item[key] = +item[key];
          } else {
            item[key] = item[key] ? item[key] + '' : '';
          }
        }
      });
      if (isPass) {
        this.httpPost(this.$root.importOrder, list).then(
          (res) => {
            this.$message.success('导入成功！');
            this.getOrderList();
          },
          (err) => {
            this.$message.error(err);
          }
        );
      }
    },
    async order2excel() {
      this.loading++;
      let orderList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        oid: +this.filters.oid,
        uid: +this.filters.uid, // 用户id
        status: +this.filters.status, // 订单状态
        begin: this.filters.start_time,
        end: this.filters.end_time,
        province: this.filters.province, // 省
        city: this.filters.city, // 市
        county: this.filters.county, // 区
        sid: this.filters.sid,
        genre: this.filters.genre
      };
      if (this.filters.oid === '') {
        delete data.oid;
      }
      if (this.filters.uid === '') {
        delete data.uid;
      }
      if (this.filters.status === '') {
        delete data.status;
      }
      await this.httpGet(this.$root.orderList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, orderList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(orderList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          oid: +this.filters.oid,
          uid: +this.filters.uid, // 用户id
          status: +this.filters.status, // 订单状态
          begin: this.filters.start_time,
          end: this.filters.end_time,
          province: this.filters.province, // 省
          city: this.filters.city, // 市
          county: this.filters.county, // 区
          sid: this.filters.sid,
          genre: this.filters.genre
        };
        if (this.filters.oid === '') {
          delete data.oid;
        }
        if (this.filters.uid === '') {
          delete data.uid;
        }
        if (this.filters.status === '') {
          delete data.status;
        }
        await this.httpGet(this.$root.orderList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    getState(code) {
      let state = '无';
      this.statusList.forEach((item) => {
        if (item.id === code) {
          state = item.val;
        }
      });
      return state;
    },
    getSum(arr) {
      // 合并商品规格单元格
      let str = '';
      arr.forEach((item1, index) => {
        let name =
          item1.name +
          '(' +
          item1.attrs[0].keyName +
          item1.attrs[0].value +
          ')x' +
          item1.num +
          '商家名称：' +
          item1.attrs[0].sid;
        str = str === '' ? name : str + ';' + name;
      });
      return str;
    },
    getAttrs(attrs) {
      return attrs
        .map((item) => {
          return item.keyName + '：' + item.value;
        })
        .join('; ');
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        // let count = 0;
        item.skuList.forEach((sku) => {
          let obj = {
            订单号: item.oid,
            购买人ID: item.uid,
            购买人昵称: item.nickname,
            商品名称: sku.name,
            商品规格: this.getAttrs(sku.attrs),
            商品数量: sku.num,
            商品单价: sku.price,
            商品实付总价: sku.payment,
            // 商家名称: sku.shopName,
            // 成本: sku.cost,
            收货地址:
              item.provinceStr + item.cityStr + item.countyStr + item.address,
            收件人姓名: item.name,
            收件人联系电话: item.phone,
            下单时间: item.created,
            订单状态: this.statusMap[item.status],
            付款金额: item.due,
            物流公司: item.company || '无',
            物流单号: item.code || '无'
          };
          formatList.push(obj);
          // count++;
        });
      });
      myUtils.json2excel(formatList);
    }
  },
  watch: {
    timeRange(val) {
      if (val === null) {
        this.filters.start_time = null;
        this.filters.end_time = null;
        return false;
      }
      let start = dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss');
      let end = dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss');
      this.filters.start_time = start;
      this.filters.end_time = end;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
@import '~assets/public.styl';

.table-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter {
        position: relative;
      }

      .import-box {
        position: absolute;
        right: 0;
        bottom: 0;

        .search {
          position: relative;
          margin-left: 8px;

          .search-input {
            position: absolute;
            opacity: 0;
            width: 65px;
            left: 0;
            top: 0;
          }
        }
      }

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        // margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 32px;
      }

      .select, .input {
        width: 150px;
      }

      .date-input {
        width: 320px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
}
</style>
